import { PropType, defineComponent, ref, watch } from "vue";
import { KahiDetailRelationData, KahiLatLng } from "@/@types";
import KahiMetaInfo from "@/components/KahiMetaInfo/KahiMetaInfo.vue";
import { breakLineUta, convertDistance } from "@/filters";
import store from "@/store";

export default defineComponent({
  name: "KahiDetailRelation",
  components: {
    KahiMetaInfo
  },
  props: {
    kahi: {
      type: Object as PropType<KahiDetailRelationData>,
      required: true
    },
    isLink: {
      type: Boolean,
      required: true
    },
    coords: {
      type: Object as PropType<KahiLatLng>,
      required: false
    }
  },
  async setup(props) {
    const splice = ref(props.isLink ? null : 7);
    const distance = ref<number | null>(null);
    const hasDistance = ref(false);

    if (props.coords) {
      const calcurateDistance = async () => {
        distance.value = await store.dispatch(
          "kahi/calcurateDistance",
          props.coords
        );
      };

      watch(
        () => store.state.kahi.currentPosition,
        async () => {
          await calcurateDistance();
        }
      );

      await calcurateDistance();
      hasDistance.value = true;
    }

    return {
      distance,
      hasDistance,
      splice,
      breakLineUta,
      convertDistance
    };
  }
});
